// import { useMemo } from 'react';
import { Form } from 'antd';
import { useResolution886Report } from '@/context/Resolution886Report';

const { useWatch } = Form;

export function useActionPlanQuestions() {
	const { form } = useResolution886Report();
	const allFormValues = useWatch([], form);

	return { allFormValues };
}
